export default __webpack_public_path__ + "static/lframe-caravan-loan-8275ee4dd6633d005663b1435726bf32.webp";